/* eslint-disable no-console */
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationRef, enableProdMode, importProvidersFrom } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { OAuthStorage } from 'angular-oauth2-oidc';

import { routes } from './app/app-routing.config';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { OFFICE_HOST_TYPE, WIDGET_HOST_TYPE } from './app/shared/tokens';
import { AuthGuard, AuthGuardNoRedirect } from './app/shared/utils/auth.guard';
import { allEffects } from './app/store/effects';
import { metaReducers, reducers } from './app/store/reducers';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (typeof Office !== 'undefined') {
  Office.onReady()
    .then((info: { host: Office.HostType; platform: Office.PlatformType }) => {
      console.log('Office is ready');
      return bootStrapAngular(info.host);
    })
    .catch((err) => {
      console.warn('Angular not bootstrapped. Error: \n');
      console.log(err);
    });
} else {
  bootStrapAngular(null);
}

/**
 * Bootstraps the Angular application.
 * @param host The Office host type.
 * @returns A promise that resolves when the application is bootstrapped.
 */
function bootStrapAngular(host: Office.HostType | null): Promise<void | ApplicationRef> {
  return bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(AppModule),
      AuthGuard,
      AuthGuardNoRedirect,
      DatePipe,
      MatDatepickerModule,
      { provide: OFFICE_HOST_TYPE, useValue: host },
      { provide: WIDGET_HOST_TYPE, useValue: false },
      // outlook client (vs browser) doesn't share sessionStorage between windows
      // so KEEP OAuth using localStorage
      { provide: OAuthStorage, useFactory: () => localStorage },
      provideRouter(routes),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi()),
      provideStore(reducers, {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      }),
      provideEffects(allEffects),
    ],
  }).catch((error) => {
    console.log('Error bootstrapping Office Angular app: ', error);
  });
}
